<script>
import Chart from 'chart.js'
import { Doughnut, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
    extends: Doughnut,
    mixins: [reactiveProp],
    props: {
        chartData: { type: Object, required: true },
        options: { type: Object, default: () => ({}) },
        styles: { type: Object, default: () => ({ height: '100%', position: 'relative' }) },
    },
    mounted() {
        if (this.chartData && this.chartData.datasets) {
            this.renderChart(this.chartData, this.options)
        }
    },
}
</script>
